import {type AjaxDataTypes} from '../../../../../shared/AjaxDataTypes.ts'
import {AnalyticEventType, AnalyticEventCategory, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas.ts'
import {StoreItemCategory, StoreMapType} from '../../../../../shared/entity_datas/StoreEnums.ts'
import {StoreExpansionType} from '@colonist/types'
import {MapSettingEnum, ModeSettingEnum} from '../../../../../shared/GameEnums.ts'
import {type GameSettings} from '@colonist/game-base-types'
import {getNestedTranslation, type TranslationObject} from '@colonist/i18n'
import {type BaseStoreItem} from '../../../../../shared/store/BaseStoreItem.ts'
import {StoreItemController} from '../../../../../shared/store/StoreItemController.ts'
import {RandomUtils} from '@colonist/utils'
import {CA} from '../../analytics/Analytics.ts'
import {createDivIn, createImgIn, createParagraphIn, setElementInnerHTML} from '../../ui_utils/DomUtils.ts'
import {ViewPopup} from '../ViewPopup.ts'
import {navigateToPage} from '../../ui_utils/ClientUtils.ts'

export class ViewPopupMembershipIncentiveEndgame extends ViewPopup {
    constructor(continuationAction: () => void, gameSettings: GameSettings, continuationText: TranslationObject) {
        const visitStoreButtonAction = () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.PopupMembershipIncentiveEndgame,
            }
            void CA.sendAnalyticEvent(eventData)
            navigateToPage('/store#membership', true)
        }

        const allActiveMaps = StoreItemController.getItemsInCategory(StoreItemCategory.Map, true)
        const allActiveExpansions = StoreItemController.getItemsInCategory(StoreItemCategory.Expansion, true)

        const availableMaps = allActiveMaps.filter((map: BaseStoreItem) => {
            // removes the map that was just played from the list of available maps
            switch(map.type as StoreMapType) {
                case StoreMapType.BlackForest:
                    return gameSettings.mapSetting !== MapSettingEnum.BlackForest
                case StoreMapType.Classic4PRandom:
                    return gameSettings.mapSetting !== MapSettingEnum.Classic4PRandom
                case StoreMapType.Diamond:
                    return gameSettings.mapSetting !== MapSettingEnum.Diamond
                case StoreMapType.Earth:
                    return gameSettings.mapSetting !== MapSettingEnum.Earth
                case StoreMapType.Gear:
                    return gameSettings.mapSetting !== MapSettingEnum.Gear
                case StoreMapType.GoldRush:
                    return gameSettings.mapSetting !== MapSettingEnum.GoldRush
                case StoreMapType.Lakes:
                    return gameSettings.mapSetting !== MapSettingEnum.Lakes
                case StoreMapType.Pond:
                    return gameSettings.mapSetting !== MapSettingEnum.Pond
                case StoreMapType.ShuffleBoard:
                    return gameSettings.mapSetting !== MapSettingEnum.ShuffleBoard
                case StoreMapType.Twirl:
                    return gameSettings.mapSetting !== MapSettingEnum.Twirl
                case StoreMapType.UK:
                    return gameSettings.mapSetting !== MapSettingEnum.UK
                case StoreMapType.USA:
                    return gameSettings.mapSetting !== MapSettingEnum.USA
                case StoreMapType.Volcano:
                    return gameSettings.mapSetting !== MapSettingEnum.Volcano
                default:
                    return true
            }
        })

        const availableExpansions = allActiveExpansions.filter((expansion: BaseStoreItem) => {
            // removes the expansion that was just played from the list of available expansions
            switch(expansion.type as StoreExpansionType) {
                case StoreExpansionType.CitiesAndKnights4P:
                    return gameSettings.modeSetting !== ModeSettingEnum.CitiesAndKnights4P
                case StoreExpansionType.CitiesAndKnights56P:
                    return gameSettings.modeSetting !== ModeSettingEnum.CitiesAndKnights56P
                case StoreExpansionType.CitiesAndKnightsSeafarers4P:
                    return gameSettings.modeSetting !== ModeSettingEnum.CitiesAndKnightsSeafarers4P
                case StoreExpansionType.CitiesAndKnightsSeafarers56P:
                    return gameSettings.modeSetting !== ModeSettingEnum.CitiesAndKnightsSeafarers56P
                case StoreExpansionType.Classic56P:
                    return gameSettings.modeSetting !== ModeSettingEnum.Classic56P
                case StoreExpansionType.Classic78P:
                    return gameSettings.modeSetting !== ModeSettingEnum.Classic78P
                case StoreExpansionType.Seafarers4P:
                    return gameSettings.modeSetting !== ModeSettingEnum.Seafarers4P
                case StoreExpansionType.Seafarers56P:
                    return gameSettings.modeSetting !== ModeSettingEnum.Seafarers56P
                default:
                    return true
            }
        })
        super({key: 'strings:homePage.becomeAMember'}, {key: 'strings:colonistCommon.utils.emptyString'}, visitStoreButtonAction, continuationAction, true)
        this.body.style.flexDirection = 'column'
        const showMapsInsteadOfExpansions = RandomUtils.randomBool()

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
        const blurb = getNestedTranslation({key: 'strings:popups.membershipIncentive.body'}, {
            value: showMapsInsteadOfExpansions ? {key: 'strings:popups.membershipIncentive.optionMaps'} : {key: 'strings:popups.membershipIncentive.optionExpansions'},
        })
        createParagraphIn(this.body, blurb, 'popup-membership-body')

        const imageWrapper = createDivIn(this.body, 'popup-subscription-in-room-items-wrapper', '')
        const itemsToShow = showMapsInsteadOfExpansions ? availableMaps : availableExpansions
        itemsToShow.forEach((itemDetail) => {
            const imageCard = createDivIn(imageWrapper, 'popup-subscription-in-room-item-img', '')
            createImgIn(imageCard, itemDetail.image)
            createParagraphIn(imageCard, itemDetail.name, '')
            imageWrapper.appendChild(imageCard)
        })

        this.changeCheckButtonText({key: 'strings:popups.membershipIncentive.visitStore'})
        this.checkButton.id = 'store-href'
        this.changeXButtonText(continuationText)
        this.show()
    }
}
